<template>
  <div>
    <div v-if="asyncDataStatus_ready" class="cms">
      <v-row justify="space-between">
        <v-col cols="12" sm="10" md="6">
          <v-row>
            <v-col cols="12">
              <DateTimeSelector
                labelDate="Od"
                :date="startDate"
                :time="startTime"
                @change="updateStartDateTime"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <DateTimeSelector
                labelDate="Do"
                :date="endDate"
                :time="endTime"
                @change="updateEndDateTime"
              />
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" md="auto">
          <v-btn
            color="#0F998E"
            class="white--text mt-2 float-right d-inlineblock"
            @click="search"
          >
            Išči
            <v-icon right dark>fas fa-search</v-icon>
          </v-btn>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" v-show="loading">
          <AppSpinner />
        </v-col>
        <v-col cols="12" lg="6" v-show="!loading && response">
          <SourceFileCard
            v-if="response !== null"
            :contents="response.head_contents"
            :filename="response.head_filename"
            :lines="response.head_lines"
            :md5="response.head_md5"
            :sha1="response.head_sha1"
          />
        </v-col>
        <v-col cols="12" lg="6" v-show="!loading && response">
          <SourceFileCard
            v-if="response !== null"
            :contents="response.items_contents"
            :filename="response.items_filename"
            :lines="response.items_lines"
            :md5="response.items_md5"
            :sha1="response.items_sha1"
          />
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { mapActions } from 'vuex'
import asyncDataStatus from '@/mixins/asyncDataStatus'
import DateTimeSelector from '@/components/DateTimeSelector'
import SourceFileCard from '@/components/SourceFileCard'

export default {
  components: {
    AppSpinner: () => import('@/components/AppSpinner'),
    DateTimeSelector,
    SourceFileCard
  },
  mixins: [
    asyncDataStatus
  ],
  props: {
    childCompanyId: {
      required: true,
      type: Number
    },
    businessUnitId: {
      required: true,
      type: Number
    },
    deviceId: {
      required: true,
      type: Number
    }
  },
  data () {
    return {
      startDate: '',
      startTime: '00:00',
      endDate: '',
      endTime: '23:59',
      response: null,
      loading: false
    }
  },
  computed: {
    params () {
      return {
        startDate: this.startDate,
        startTime: `${this.startTime}:00`,
        endDate: this.endDate,
        endTime: `${this.endTime}:59`,
        deviceId: this.deviceId,
        childCompanyId: this.childCompanyId,
        businessUnitId: this.businessUnitId

      }
    }
  },
  methods: {
    ...mapActions('devices', ['sourceFile']),
    search () {
      this.loading = true
      this.reportData = []
      this.sourceFile(this.params)
        .then(response => {
          this.loading = false
          this.response = response
        })
        .catch(anErr => {
          this.loading = false
          this.$notify({
            type: 'error',
            text: 'Prišlo je do napake pri generiranju izvorne datoteke.'
          })
        })
    },
    updateStartDateTime ({ date, time }) {
      this.startDate = date
      this.startTime = time
    },
    updateEndDateTime ({ date, time }) {
      this.endDate = date
      this.endTime = time
    }
  },
  created () {
    const today = moment().format('YYYY-MM-DD')
    this.startDate = today
    this.endDate = today
    this.asyncDataStatus_fetched()
  }
}
</script>
